import {
  LlmDeliveryServiceItem,
  LlmDeliveryServiceRatingItem,
  LlmServiceAction,
  RESET_CURRENT_LLM_SERVICE,
  SET_CURRENT_LLM_SERVICE,
  SET_LLM_RATING_COUNT,
  SET_LLM_RATING_LIST,
  SET_LLM_SERVICE_COUNT,
  SET_LLM_SERVICE_HAS_NEXT,
  SET_LLM_SERVICE_LIST,
} from './types';

export interface LlmServiceState {
  llmServiceList: Array<LlmDeliveryServiceItem>,
  llmServiceCount: number,
  hasNext: boolean,
  currentLlmService: LlmDeliveryServiceItem | null,
  llmRatingList: Array<LlmDeliveryServiceRatingItem>,
  llmRatingCount: number,
}

const initialState: LlmServiceState = {
  llmServiceList: [],
  llmServiceCount: 0,
  hasNext: false,
  currentLlmService: null,
  llmRatingList: [],
  llmRatingCount: 0,
};

export default function (state = initialState, action: LlmServiceAction): LlmServiceState {
  switch (action.type) {
    case SET_LLM_SERVICE_LIST:
      return { ...state, llmServiceList: action.payload };
    case SET_LLM_SERVICE_COUNT:
      return { ...state, llmServiceCount: action.payload };
    case SET_LLM_SERVICE_HAS_NEXT:
      return { ...state, hasNext: action.payload };
    case SET_CURRENT_LLM_SERVICE:
      return { ...state, currentLlmService: action.payload };
    case SET_LLM_RATING_LIST:
      return { ...state, llmRatingList: action.payload };
    case SET_LLM_RATING_COUNT:
      return { ...state, llmRatingCount: action.payload };
    case RESET_CURRENT_LLM_SERVICE:
      return {
        ...state,
        currentLlmService: initialState.currentLlmService,
        llmRatingList: initialState.llmRatingList,
        llmRatingCount: initialState.llmRatingCount,
      };
    default: return state;
  }
}
